export const environment = {
  production: true,
  SERVER_URL: 'https://api2.sokoa.com',
  FILE_ENDPOINT: 'https://api2.sokoa.com/api/document/upload',
  DATA_ENDPOINT: 'https://api2.sokoa.com/api/document/',
};
